import React from "react";
import PropTypes from "prop-types";

const AlphabeticalFilterList = ({
    selected,
    values,
    linkKey,
    titleKey,
    linkPrefix
}) => {
    return(
        <div className="manufacturerList my-4">
            <div className="alphaSelection">
                <h2>{selected}</h2>
            </div>
            {values.length > 0 && (
                <div className="five-columns mb-4">
                    {values.map((value)=>{
                        let title = value[titleKey],
                            link = linkPrefix ? `${linkPrefix}${value[linkKey]}`: value[linkKey];

                        return (
                            <div key={`${title}-${link}`} className="manufacturer align-self-center mx-4 my-4">
                                <h2>
                                    <a href={link}>{title}</a>
                                </h2>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

AlphabeticalFilterList.propTypes = {
    selected: PropTypes.string,
    values: PropTypes.array,
    titleKey: PropTypes.string.isRequired,
    linkKey: PropTypes.string.isRequired,
    linkPrefix: PropTypes.string
};

export default AlphabeticalFilterList;
